import React, { FC } from 'react';

import translate from '../../../i18n/translate';

import SkeletonMessages from '../Messages';

/**
 * Skeleton for the feed
 *
 * @returns The component itself
 */
const SkeletonFeedInitial: FC = () => {
  return (
    <SkeletonMessages
      avatarSize={40}
      description={translate('LOADING__MESSAGES')}
      nrMessages={5}
      shouldShowSkeleton={true}
    />
  );
};

export default SkeletonFeedInitial;
